import { makeHttpRequest } from "@/shared";

import { mapCalculatedRepairFromServer } from "./mappers/mapCalculatedRepairFromServer";
import { mapRepairServiceToServer } from "./mappers/mapRepairServiceToServer.js";
export const removeRepairService = async (sessionKey, service) => {
    const response = (
        await makeHttpRequest({
            url: `/repair/builder/${sessionKey}/remove/service`,
            method: "DELETE",
            data: mapRepairServiceToServer(service),
        })
    ).data;

    return mapCalculatedRepairFromServer(response.data);
};
